/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaMarcasVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaMarcas: React.FunctionComponent<ITablaMarcasVistaProps & InjectedIntlProps> = ({
    marcass,
    cargarMarcas,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={marcass}
            actions={acciones(manejarFormulario, cargarMarcas, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaMarcas);
